import type { ActionInfo } from '../../globals';

/* action type */
export const CREATE_DATA_OBJECT = 'CREATE_DATA_OBJECT';

/* action creator */
export const createDataObjectAction = (actionPayload: ActionInfo) => {
  return {
    type: CREATE_DATA_OBJECT,
    payload: actionPayload
  };
};
